import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/placeAreaPrice/placeAreaPrice';
export default {
  props: ['keyValue', 'showDialog', 'areaId'],
  data: function data() {
    return {
      rules: {
        priceName: [{
          required: true,
          message: '请选择开始时间和结束时间',
          trigger: 'blur'
        }, {
          min: 1,
          max: 100,
          message: '长度在 1 到 100 个字符',
          trigger: 'change'
        }],
        price: [{
          required: true,
          message: '请输入单价',
          trigger: 'blur'
        }],
        startTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          message: '请选择结束时间',
          trigger: 'change'
        }]
      },
      childData: {
        priceName: '',
        areaId: '',
        startTime: '',
        endTime: ''
      }
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  computed: {
    priceName: function priceName() {
      if (this.childData.startTime && this.childData.endTime) return "".concat(this.childData.startTime, "-").concat(this.childData.endTime);
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.childData = {
          priceName: ''
        };
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$set(this.childData, "priceName", this.priceName);
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this2.childData.startTime > _this2.childData.endTime) {
            _this2.Alert({
              alertType: 'error',
              message: '开始时间不能大于结束时间'
            });

            return;
          }

          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function (res) {
              if (res.data.code == 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'update'
                });
              }
            });
          } else {
            _this2.childData.areaId = _this2.areaId;
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code == 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'add'
                });
              }
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};